import { useReducer, useEffect, useRef } from 'react';

const PATCH = '@action_types/PATCH';
const DERIVE = '@action_types/DERIVE';

const noop = () => {};

const isObject = (arg) => {
  return arg === Object(arg) && !Array.isArray(arg);
};

const reducer = (state, action) => {
  switch ( action.type ) {
    case PATCH:
      return {
        ...state,
        ...action.payload,
      };
    case DERIVE:
      return {
        ...state,
        ...action.updater(state),
      };
    default: console.error(`Unexpected action type: ${action.type}`); return state;
  }
};

const useSetState = (initState) => {
  const [_state, dispatch] = useReducer(reducer, initState);

  const updateStateWithObj = update => dispatch({ type: PATCH, payload: update });
  const updateStateWithFunc = updater => dispatch({ type: DERIVE, updater });

  const setStateCallback = useRef();

  useEffect(() => {
    if ( typeof setStateCallback.current === 'function' ) {
      setStateCallback.current();
    }
    setStateCallback.current = noop;
  }, [_state]);

  const setState = (arg, callback = noop) => {
    setStateCallback.current = callback;
    if ( typeof arg === 'function' ) {
      updateStateWithFunc(arg);
    } else if ( isObject(arg) ) {
      updateStateWithObj(arg);
    } else {
      throw Error(
        'Invalid argument type passed to setState. Argument must either be a plain object or' +
        'an updater function.'
      );
    }
  };

  return [_state, setState];
};

export default useSetState;
